// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upskld_home_pg_root {
  --thumb-scale: 0.11;
  --thumb-gap: 14px;
  --thumb-bottom: 28px;
  --fade-duration: 0.9s;
  --fade-ease: ease-in-out;
  background: #0b0b0f;
  color: #fff;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  position: relative;
  width: 100%;
}

/* ---------- LARGE TABLET / SMALL LAPTOP ---------- */
@media (max-width: 1024px) {
  .upskld_home_pg_root {
    --thumb-scale: 0.13;
    --thumb-gap: 12px;
    --thumb-bottom: 22px;
    height: 62vh;
    height: 62dvh;
  }
}

/* ---------- TABLET / LARGE PHONE LANDSCAPE ---------- */
@media (max-width: 768px) {
  .upskld_home_pg_root {
    --thumb-scale: 0.15;
    --thumb-gap: 10px;
    --thumb-bottom: 20px;
    height: 58vh;
    height: 58dvh;
  }
}

/* ---------- STANDARD PHONES (most Android devices) ---------- */
@media (max-width: 480px) {
  .upskld_home_pg_root {
    --thumb-scale: 0.17;
    --thumb-gap: 8px;
    --thumb-bottom: 16px;
    height: 52vh;
    height: 52dvh;
  }
}

/* ---------- COMMON ANDROID WIDTHS (Pixel, Galaxy S, OnePlus) ---------- */
@media (max-width: 430px) {
  .upskld_home_pg_root {
    --thumb-scale: 0.19;
    --thumb-gap: 7px;
    --thumb-bottom: 14px;
    height: 50vh;
    height: 50dvh;
  }
}

@media (max-width: 393px) {
  .upskld_home_pg_root {
    --thumb-scale: 0.21;
    --thumb-gap: 6px;
    --thumb-bottom: 12px;
    height: 48vh;
    height: 48dvh;
  }
}

/* ---------- MINIMUM SUPPORTED WIDTH ---------- */
@media (max-width: 360px) {
  .upskld_home_pg_root {
    --thumb-scale: 0.23;
    --thumb-gap: 5px;
    --thumb-bottom: 10px;
    height: 46vh;
    height: 46dvh;
  }
}

.upskld_home_pg_gallery {
  height: 100%;
  width: 100%;
}

.upskld_home_pg_track {
  height: 100%;
  overflow: visible !important;
}

.upskld_home_pg_item {
  inset: 0 !important;
  margin: 0 !important;
  pointer-events: none !important;
  position: absolute !important;
  transform: none !important;
  width: auto !important;
}

.upskld_home_pg_item[data-active='true'] {
  z-index: 1 !important;
}

.upskld_home_pg_item[data-active='false'] {
  z-index: 10 !important;
}

.upskld_home_pg_slide {
  border-radius: 0;
  inset: 0;
  overflow: hidden;
  pointer-events: auto;
  position: absolute;
  transform: translate3d(0, 0, 0) scale(1);
  opacity: 1;
  transition:
    transform var(--fade-duration) var(--fade-ease),
    border-radius var(--fade-duration) var(--fade-ease),
    opacity var(--fade-duration) var(--fade-ease);
  will-change: transform, opacity;
}

.upskld_home_pg_item[data-active='false'] .upskld_home_pg_slide {
  border-radius: 32px;
  opacity: 0.55;
  transform: translate3d(
      calc(var(--offset) * (var(--thumb-scale) * 60vw + var(--thumb-gap))),
      calc((50% - var(--thumb-scale) * 50%) - var(--thumb-bottom)),
      0
    )
    scale(var(--thumb-scale));
}

.upskld_home_pg_item[data-active='false'] .upskld_home_pg_slide:hover,
.upskld_home_pg_item[data-active='false'] .upskld_home_pg_slide:active {
  opacity: 1;
}

.upskld_home_pg_image {
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  width: 100%;
  transition: opacity var(--fade-duration) var(--fade-ease);
}

/* Nudge focal point on shorter banners so the subject stays visible */
@media (max-width: 1024px) {
  .upskld_home_pg_image {
    object-position: 65% center;
  }
}

@media (max-width: 768px) {
  .upskld_home_pg_image {
    object-position: 70% center;
  }
}

@media (max-width: 430px) {
  .upskld_home_pg_image {
    object-position: 74% center;
  }
}

.upskld_home_pg_thumb_btn {
  appearance: none;
  background: none;
  border: 0;
  cursor: pointer;
  inset: 0;
  padding: 0;
  position: absolute;
}

.upskld_home_pg_rail {
  align-items: flex-start;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.64), transparent);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: clamp(1rem, 3vw, 2rem);
  inset: 0 auto 0 0;
  justify-content: flex-end;
  max-width: min(770px, 70%);
  padding: env(safe-area-inset-top, 0) 3.5rem clamp(1.5rem, 6vh, 3rem) 3rem;
  padding-left: max(3rem, env(safe-area-inset-left, 0px));
  pointer-events: none;
  position: absolute;
  width: 100%;
  z-index: 5;
}

.upskld_home_pg_content {
  animation: upskld_home_pg_content_in var(--fade-duration) var(--fade-ease) both;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 12px 14px;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
}

@keyframes upskld_home_pg_content_in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.upskld_home_pg_kicker {
  font-size: 0.8rem;
  margin: 0;
  opacity: 0.7;
}

.upskld_home_pg_title {
  font-size: clamp(1.35rem, 4.5vw, 3rem);
  line-height: 1.12;
  margin: 0;
}

.upskld_home_pg_description {
  color: rgba(255, 255, 255, 0.85);
  font-size: clamp(0.8rem, 1.4vw, 1.05rem);
  line-height: 1.55;
  margin: 0;
}

.upskld_home_pg_controls {
  display: flex;
  gap: 0.75rem;
  pointer-events: auto;
}

.upskld_home_pg_nav_btn {
  align-items: center;
  appearance: none;
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  height: 3rem;
  justify-content: center;
  min-height: 44px;
  min-width: 44px;
  transition: background 0.2s, border-color 0.2s, opacity 0.2s;
  width: 3rem;
}

.upskld_home_pg_nav_btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.4);
}

.upskld_home_pg_nav_btn:disabled {
  cursor: default;
  opacity: 0.35;
}

.upskld_home_pg_visually_hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* ---------- RESPONSIVE RAIL WIDTH ---------- */
@media (max-width: 1024px) {
  .upskld_home_pg_rail {
    max-width: 82%;
    padding-right: 2rem;
  }
}

@media (max-width: 768px) {
  .upskld_home_pg_rail {
    max-width: 92%;
    padding-right: 1.5rem;
  }
}

@media (max-width: 480px) {
  .upskld_home_pg_rail {
    max-width: 100%;
    padding-right: 1.1rem;
    padding-left: max(1.1rem, env(safe-area-inset-left, 0px));
    gap: 1rem;
  }

  .upskld_home_pg_content {
    padding: 10px 12px;
  }
}

@media (max-width: 360px) {
  .upskld_home_pg_rail {
    padding-right: 0.9rem;
    padding-left: max(0.9rem, env(safe-area-inset-left, 0px));
    padding-bottom: 1.1rem;
  }

  .upskld_home_pg_nav_btn {
    height: 2.5rem;
    width: 2.5rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .upskld_home_pg_slide,
  .upskld_home_pg_image {
    transition: none;
  }
  .upskld_home_pg_content {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,yDAAyD;AACzD;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,iEAAiE;AACjE;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV;;;iDAG+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb;;;;;6BAK2B;AAC7B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;EACX,yDAAyD;AAC3D;;AAEA,sEAAsE;AACtE;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oEAAoE;EACpE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yEAAyE;EACzE,uDAAuD;EACvD,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,+EAA+E;EAC/E,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;IACrB,yDAAyD;IACzD,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,yDAAyD;IACzD,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".upskld_home_pg_root {\n  --thumb-scale: 0.11;\n  --thumb-gap: 14px;\n  --thumb-bottom: 28px;\n  --fade-duration: 0.9s;\n  --fade-ease: ease-in-out;\n  background: #0b0b0f;\n  color: #fff;\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n/* ---------- LARGE TABLET / SMALL LAPTOP ---------- */\n@media (max-width: 1024px) {\n  .upskld_home_pg_root {\n    --thumb-scale: 0.13;\n    --thumb-gap: 12px;\n    --thumb-bottom: 22px;\n    height: 62vh;\n    height: 62dvh;\n  }\n}\n\n/* ---------- TABLET / LARGE PHONE LANDSCAPE ---------- */\n@media (max-width: 768px) {\n  .upskld_home_pg_root {\n    --thumb-scale: 0.15;\n    --thumb-gap: 10px;\n    --thumb-bottom: 20px;\n    height: 58vh;\n    height: 58dvh;\n  }\n}\n\n/* ---------- STANDARD PHONES (most Android devices) ---------- */\n@media (max-width: 480px) {\n  .upskld_home_pg_root {\n    --thumb-scale: 0.17;\n    --thumb-gap: 8px;\n    --thumb-bottom: 16px;\n    height: 52vh;\n    height: 52dvh;\n  }\n}\n\n/* ---------- COMMON ANDROID WIDTHS (Pixel, Galaxy S, OnePlus) ---------- */\n@media (max-width: 430px) {\n  .upskld_home_pg_root {\n    --thumb-scale: 0.19;\n    --thumb-gap: 7px;\n    --thumb-bottom: 14px;\n    height: 50vh;\n    height: 50dvh;\n  }\n}\n\n@media (max-width: 393px) {\n  .upskld_home_pg_root {\n    --thumb-scale: 0.21;\n    --thumb-gap: 6px;\n    --thumb-bottom: 12px;\n    height: 48vh;\n    height: 48dvh;\n  }\n}\n\n/* ---------- MINIMUM SUPPORTED WIDTH ---------- */\n@media (max-width: 360px) {\n  .upskld_home_pg_root {\n    --thumb-scale: 0.23;\n    --thumb-gap: 5px;\n    --thumb-bottom: 10px;\n    height: 46vh;\n    height: 46dvh;\n  }\n}\n\n.upskld_home_pg_gallery {\n  height: 100%;\n  width: 100%;\n}\n\n.upskld_home_pg_track {\n  height: 100%;\n  overflow: visible !important;\n}\n\n.upskld_home_pg_item {\n  inset: 0 !important;\n  margin: 0 !important;\n  pointer-events: none !important;\n  position: absolute !important;\n  transform: none !important;\n  width: auto !important;\n}\n\n.upskld_home_pg_item[data-active='true'] {\n  z-index: 1 !important;\n}\n\n.upskld_home_pg_item[data-active='false'] {\n  z-index: 10 !important;\n}\n\n.upskld_home_pg_slide {\n  border-radius: 0;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: auto;\n  position: absolute;\n  transform: translate3d(0, 0, 0) scale(1);\n  opacity: 1;\n  transition:\n    transform var(--fade-duration) var(--fade-ease),\n    border-radius var(--fade-duration) var(--fade-ease),\n    opacity var(--fade-duration) var(--fade-ease);\n  will-change: transform, opacity;\n}\n\n.upskld_home_pg_item[data-active='false'] .upskld_home_pg_slide {\n  border-radius: 32px;\n  opacity: 0.55;\n  transform: translate3d(\n      calc(var(--offset) * (var(--thumb-scale) * 60vw + var(--thumb-gap))),\n      calc((50% - var(--thumb-scale) * 50%) - var(--thumb-bottom)),\n      0\n    )\n    scale(var(--thumb-scale));\n}\n\n.upskld_home_pg_item[data-active='false'] .upskld_home_pg_slide:hover,\n.upskld_home_pg_item[data-active='false'] .upskld_home_pg_slide:active {\n  opacity: 1;\n}\n\n.upskld_home_pg_image {\n  display: block;\n  height: 100%;\n  object-fit: cover;\n  object-position: center center;\n  width: 100%;\n  transition: opacity var(--fade-duration) var(--fade-ease);\n}\n\n/* Nudge focal point on shorter banners so the subject stays visible */\n@media (max-width: 1024px) {\n  .upskld_home_pg_image {\n    object-position: 65% center;\n  }\n}\n\n@media (max-width: 768px) {\n  .upskld_home_pg_image {\n    object-position: 70% center;\n  }\n}\n\n@media (max-width: 430px) {\n  .upskld_home_pg_image {\n    object-position: 74% center;\n  }\n}\n\n.upskld_home_pg_thumb_btn {\n  appearance: none;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  inset: 0;\n  padding: 0;\n  position: absolute;\n}\n\n.upskld_home_pg_rail {\n  align-items: flex-start;\n  background: linear-gradient(90deg, rgba(0, 0, 0, 0.64), transparent);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1rem, 3vw, 2rem);\n  inset: 0 auto 0 0;\n  justify-content: flex-end;\n  max-width: min(770px, 70%);\n  padding: env(safe-area-inset-top, 0) 3.5rem clamp(1.5rem, 6vh, 3rem) 3rem;\n  padding-left: max(3rem, env(safe-area-inset-left, 0px));\n  pointer-events: none;\n  position: absolute;\n  width: 100%;\n  z-index: 5;\n}\n\n.upskld_home_pg_content {\n  animation: upskld_home_pg_content_in var(--fade-duration) var(--fade-ease) both;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 12px 14px;\n  width: fit-content;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n@keyframes upskld_home_pg_content_in {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.upskld_home_pg_kicker {\n  font-size: 0.8rem;\n  margin: 0;\n  opacity: 0.7;\n}\n\n.upskld_home_pg_title {\n  font-size: clamp(1.35rem, 4.5vw, 3rem);\n  line-height: 1.12;\n  margin: 0;\n}\n\n.upskld_home_pg_description {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: clamp(0.8rem, 1.4vw, 1.05rem);\n  line-height: 1.55;\n  margin: 0;\n}\n\n.upskld_home_pg_controls {\n  display: flex;\n  gap: 0.75rem;\n  pointer-events: auto;\n}\n\n.upskld_home_pg_nav_btn {\n  align-items: center;\n  appearance: none;\n  backdrop-filter: blur(8px);\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  height: 3rem;\n  justify-content: center;\n  min-height: 44px;\n  min-width: 44px;\n  transition: background 0.2s, border-color 0.2s, opacity 0.2s;\n  width: 3rem;\n}\n\n.upskld_home_pg_nav_btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.22);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.upskld_home_pg_nav_btn:disabled {\n  cursor: default;\n  opacity: 0.35;\n}\n\n.upskld_home_pg_visually_hidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n/* ---------- RESPONSIVE RAIL WIDTH ---------- */\n@media (max-width: 1024px) {\n  .upskld_home_pg_rail {\n    max-width: 82%;\n    padding-right: 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .upskld_home_pg_rail {\n    max-width: 92%;\n    padding-right: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .upskld_home_pg_rail {\n    max-width: 100%;\n    padding-right: 1.1rem;\n    padding-left: max(1.1rem, env(safe-area-inset-left, 0px));\n    gap: 1rem;\n  }\n\n  .upskld_home_pg_content {\n    padding: 10px 12px;\n  }\n}\n\n@media (max-width: 360px) {\n  .upskld_home_pg_rail {\n    padding-right: 0.9rem;\n    padding-left: max(0.9rem, env(safe-area-inset-left, 0px));\n    padding-bottom: 1.1rem;\n  }\n\n  .upskld_home_pg_nav_btn {\n    height: 2.5rem;\n    width: 2.5rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .upskld_home_pg_slide,\n  .upskld_home_pg_image {\n    transition: none;\n  }\n  .upskld_home_pg_content {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
